<template>
<div class="chapter">
<div class="inner_page">
<p class="author"><a id="page_iv"></a><a id="page_v"></a><a id="title"></a>JEAN-LUC NANCY</p>
<h1 class="h1">Dis-Enclosure</h1>
<p class="subtitle"><strong><em>The Deconstruction of Christianity</em></strong></p>
<p class="editor"><strong>T<span class="small">RANSLATED BY</span> B<span class="small">ETTINA</span> B<span class="small">ERGO</span>, G<span class="small">ABRIEL</span> M<span class="small">ALENFANT, AND</span> M<span class="small">ICHAEL</span> B. S<span class="small">MITH</span></strong></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?5c449e23